import { PAGE_TITLES } from "~/configs/pageTitles";
import { usePageTitle } from "~/hooks/usePageTitle";

import { TeamsMembersTabs } from "../../components/teamMembers/TeamsMembersTabs";
import styles from "./TeamMembers.module.scss";

const TeamMembersPage = () => {
  usePageTitle(PAGE_TITLES.teamMembers);

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{PAGE_TITLES.teamMembers}</h1>
      <TeamsMembersTabs />
    </div>
  );
};

export default TeamMembersPage;
